import { render, staticRenderFns } from "./veStuHygieneNormEdit.vue?vue&type=template&id=15a8007e&scoped=true"
import script from "./veStuHygieneNormEdit.vue?vue&type=script&lang=js"
export * from "./veStuHygieneNormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a8007e",
  null
  
)

export default component.exports